export default __webpack_public_path__ + "static/media/InsideEars_01.3a66be93.png";